import React from 'react'
import { FaCopy } from 'react-icons/fa'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';


const DashboardHeader = (props) => {

  var today = new Date()
  var currentHour = today.getHours()
  var greeting = ''

  if (currentHour < 12) {
    greeting = 'Good Morning'
  } else if (currentHour < 18) {
    greeting ='Good Afternoon'
  } else {
    greeting = 'Good Evening'
  }

  return (
    <header>
      <div className='container'>
        <div className="scalex__left__header">
            <div className="header__username__container">
              <h3 className='header__username'>Hi thenels...,  </h3>
              <h4 className='user__id'>Your ID: 
              
                <span>169878 &nbsp; 
                
                    <CopyToClipboard text={props.userID}>
                      <span>
                        <FaCopy 
                          onClick={() => toast.success('Copied!')} 
                          className='blueColor' 
                        /> 
                      </span>
                    </CopyToClipboard>
                
                </span> 
                </h4>

            </div>
            <h3 className='header__greeting'>{greeting}</h3>
        </div>


        {/*<div className="scalex__right__header">
            <Link to="#" className="create__order screen">
              Create Order
            </Link>
            <FaUser className='header__user__icon' />
            <IoIosNotifications className='header__notification__icon' />
  </div> */}
      </div>
    </header>
  )
}

export default DashboardHeader 